export default __webpack_public_path__ + "static/Image-feature-b8eaab32fa4c5d767f11779d268871d3.png";